import { makeAutoObservable, toJS } from 'mobx'

import { IPromoAvia, IPromoList } from 'widgets/avia'

import { MainPageAvia } from 'shared/api/avia/main-page/api.ts'
import { MainPageBeket } from 'shared/api/beket/main-page'
import { MainPageExcursions } from 'shared/api/excursions'
import { MainPageTours } from 'shared/api/tours/main-page'
import { PagesModule } from 'shared/ui/tabs-pages'

class PromoStore {
  isLoading: boolean = true
  list: IPromoList = {
    avia: null,
    excursion: null,
    buses: null,
  }

  constructor() {
    makeAutoObservable(this)
  }

  async getPromo(type: PagesModule) {
    this.isLoading = true

    try {
      let data
      switch (type) {
        case 'avia':
          data = await MainPageAvia.getPromoList()
          break
        case 'excursion':
          data = await MainPageExcursions.getPromoList()
          break
        case 'buses':
          data = await MainPageBeket.getPromoList()
          break
        case 'tours':
          data = await MainPageTours.getPromoList()
          break
        default:
          break
      }

      this.list[type] = data?.data?.data || null
    } catch (error) {
      console.error('Error fetching promo data:', error)
      this.list[type] = null
    } finally {
      this.isLoading = false
    }
  }

  getPromoState(type: PagesModule) {
    return this.list?.[type]
  }

  getCurrentPromo(
    id: string | number,
    type: PagesModule,
  ): IPromoAvia | undefined {
    const promoList = this.list?.[type]

    if (!promoList) return undefined

    const promoItem = promoList?.find((promo) => promo.id === id)

    return toJS(promoItem)
  }
}

export const promoStore = new PromoStore()
